import { useComputed, useSignal } from "@preact/signals-react"
import { analyzerChartVisibility } from "Pages/AnalyzersV2/@signals"
import useSearchDate from "../../../@hooks/useSearchDate";

export default function useAnalyzerChart(keySeries, chartData) {
	const showByPrice = useSignal('price')
	const isLoading = useSignal(false)
	const isVisible = useSignal(true)
	const seriesDiff = keySeries?.filter(({ dataKey }) => dataKey.includes('diff')) || []
	const seriesWithoutDiff = keySeries?.filter(obj => !obj.dataKey.includes(' Pr') && !obj.dataKey.includes('diff')) || []
	const seriesToApply = useComputed(() => showByPrice.value === 'price' ? seriesWithoutDiff : seriesDiff)
	const filteredChart = useSignal(chartData)
	const sitesSelected = useSignal(null)
	const showChartInFullScreen = useSignal(false)

	const toggleFullScreen = () => {
		showChartInFullScreen.value = !showChartInFullScreen.value
	}

	const onChangeShowPrice = value => {
		showByPrice.value = value
		analyzerChartVisibility.value = seriesToApply.value.map(({ dataKey }) => dataKey)
	}

	const onFilterSites = ({ value, label }) => {
		sitesSelected.value = value
		if (!value) {
			return filteredChart.value = chartData
		}
		filteredChart.value = chartData.filter(({ date }) => label === date)
	}


	const handleIsLoading = value => {
		isLoading.value = value
	}

	const titleChart = () => {
		const url = window.location.pathname
		if (url.includes('direct-site')) {
			return "Sites"
		} else if (url.includes('brokers')) {
			return "Brokers"
		} else if (url.includes('lor')) {
			return "Length of Rental"
		} else if (url.includes('dor')) {
			return "Dates of Rental"
		}
		return "Rating"
	}

	const setIsVisible = () => {
		if (isVisible.value || !!analyzerChartVisibility.value.length) {
			analyzerChartVisibility.value = []
			isVisible.value = false
		} else {
			analyzerChartVisibility.value = seriesToApply.value.map(({ dataKey }) => dataKey)
			isVisible.value = true
		}
	}

	const onLegendClick = e => {
		const value = e.target.dataItem._settings.name
		const idx = analyzerChartVisibility.value.findIndex(name => name === value)

		if (idx !== -1) {
			analyzerChartVisibility.value.splice(idx, 1)
		} else {
			analyzerChartVisibility.value.push(value)
		}
	}

	return {
		setIsVisible,
		onLegendClick,
		showByPrice: showByPrice.value,
		onChangeShowPrice,
		handleIsLoading,
		filteredChart: filteredChart.value,
		isLoading: isLoading.value,
		titleChart: titleChart(),
		hasSeriesDiff: !!seriesDiff?.length,
		seriesToApply: seriesToApply.value,
		onFilterSites,
		sitesSelected: sitesSelected.value,
		toggleFullScreen,
		showChartInFullScreen: showChartInFullScreen.value,
	}
}